export enum Signal {
  SUCCESS = 'success',
  WARNING = 'warning',
  ALERT = 'alert',
  INFO = 'info',
}
